import exists from 'exists';

import config from 'Config';
import * as dictionary from './dictionary';

export function getUrl(options) {
  if (!options.url) {
    return options.url;
  }

  function getOptionsPathParameters() {
    /*
     * TODO Remove this with issue #14434
     * Due to webedia and media-server incompatibility we need to replace hostname
     * and avoid multiple redirects. See issue #14141.
     */
    const encodedUrl = encodeURIComponent(
      (options.url || '').replace(
        'http://viaimage2.viafrance.com',
        'http://viaimage3.viafrance.com',
      ),
    );
    const optimizedDimensions = dictionary.getOptimalWidthAndHeight(options.width, options.height);
    if (!config.get('media.apiV2.enabled')) {
      return [
        options.format,
        optimizedDimensions.width,
        optimizedDimensions.height,
        options.transform,
        options.transform === 'crop' ? options.gravity : null,
        options.quality,
        encodedUrl,
      ];
    }
    return [
      encodedUrl,
      options.format,
      optimizedDimensions.width,
      optimizedDimensions.height,
      options.transform,
      options.transform === 'crop' ? options.gravity : null,
      options.quality,
    ];
  }

  if (!config.get('media.apiV2.enabled')) {
    return [config.get('media.host'), 'image']
      .concat(getOptionsPathParameters())
      .filter(exists)
      .join('/');
  }

  return [config.get('media.host'), 'v2', 'image']
    .concat(getOptionsPathParameters())
    .filter(exists)
    .join('/');
}
